<template>
  <!-- container -->
  <div class="container details mb-4 p-sm-3 col-md-8">
    <h1 class="lead d-inline-block mr-2">撮影会／イベント／教室 詳細</h1>
    <router-link to="/list" class="btn btn-new text-white">一覧ページへ</router-link>
    <div style="margin-top: 10px;" v-if="isApply">
      <a slot="footer" class="btn btn-warning text-white" href="" @click.prevent="remand">承認依頼取消</a>
      <div>※このイベントは事務局へ承認申請中のため、編集する場合は「承認依頼取消」ボタンを押して事務局への承認依頼を取り消して下さい。</div>
    </div>
    <div :is="container" :item="eventDetail"/>
    <router-link to="/list" title="" class="btn btn-new text-white">一覧ページへ</router-link>
    <p class="text-right mt-5">
      <router-link to="/mypage">マイページへのリンク</router-link>
    </p>
  </div>
</template>

<script>
import EventDetail from 'components/EventDetail'
import PhotoDetail from 'components/PhotoDetail'
import SchoolDetail from 'components/SchoolDetail'
import api from 'api'
import modal from 'util/modal'

const remandStatus = ['apply', 'reapply']

export default {
  components: {
    EventDetail,
    PhotoDetail,
    SchoolDetail
  },
  created () {
    api.fetchEvent(this, this.$route.params.id)
    .then(res => {
      this.eventDetail = { ...res, images: [res.image1, res.image2] }
    }).catch(err => {
      if (err.status === 401) {
        api.onAuthRequired(this)
      } else {
        modal.showErrorModal(this, err)
      }
    })
  },
  computed: {
    container () {
      return this.eventDetail.event_kind
      ? this.eventDetail.event_kind + '-detail'
      : 'div'
    },
    isApply () {
      return remandStatus.some(s => s === this.eventDetail.status)
    }
  },
  methods: {
    remand () {
      api.sendRemain(this, {'event_id': this.eventDetail.event_id}).then(_ => {
        this.eventDetail.status = 'notapproval'
        modal.showMessageModal(this, '差し戻しが完了しました。イベントの修正ができるようになりました。')
      }).catch(err => {
        modal.showErrorModal(this, err)
      })
    }
  },
  data () {
    return {
      eventDetail: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// Details.vue?66171259